import { Link } from "react-router-dom";
import type { Zone } from "@/mocks/zones";

const toneMap = {
  primary: {
    badge: "bg-primary-600 text-background-50",
    tag: "bg-primary-50 text-primary-700 border-primary-200",
    bar: "bg-primary-500",
  },
  accent: {
    badge: "bg-accent-500 text-foreground-950",
    tag: "bg-accent-50 text-accent-900 border-accent-200",
    bar: "bg-accent-500",
  },
  secondary: {
    badge: "bg-secondary-600 text-background-50",
    tag: "bg-secondary-50 text-secondary-800 border-secondary-200",
    bar: "bg-secondary-500",
  },
} as const;

interface ZoneCardProps {
  zone: Zone;
}

export default function ZoneCard({ zone }: ZoneCardProps) {
  const tone = toneMap[zone.tone];

  return (
    <Link
      to={`/zone/${zone.id}`}
      className="group relative flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300 cursor-pointer"
    >
      <div className="w-full aspect-[3/2] overflow-hidden bg-background-200">
        <img
          src={zone.cover}
          alt={`${zone.name}专区封面 - ${zone.subtitle}`}
          title={`${zone.name} - 爆料91专区合集`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <span className={`absolute top-3 left-3 ${tone.badge} text-[11px] px-2.5 py-1 rounded-full font-medium`}>
        {zone.category}
      </span>
      {zone.hot && (
        <span className="absolute top-3 right-3 bg-background-50/95 text-primary-700 text-[11px] px-2.5 py-1 rounded-full font-medium flex items-center gap-1">
          <i className="ri-fire-fill"></i>
          热门
        </span>
      )}

      <div className="flex flex-col flex-1 p-4 md:p-5">
        <div className="flex items-baseline justify-between gap-3">
          <h3 className="font-heading font-bold text-lg text-foreground-950 group-hover:text-primary-700 transition-colors">
            {zone.name}
          </h3>
          <span className="font-label text-xs text-foreground-500 whitespace-nowrap">
            {zone.count} 期
          </span>
        </div>
        <p className="mt-1 text-xs text-secondary-700">{zone.subtitle}</p>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-2">
          {zone.description}
        </p>

        <div className="mt-4 flex flex-wrap gap-2">
          {zone.tags.map((tag) => (
            <span key={tag} className={`text-[11px] px-2 py-1 rounded-md border ${tone.tag}`}>
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between">
          <span className="text-xs text-foreground-500">更新于 {zone.updatedAt}</span>
          <span className="text-sm text-primary-700 font-medium flex items-center gap-1">
            进入专区
            <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
          </span>
        </div>
      </div>
      <span className={`absolute bottom-0 left-0 h-0.5 w-0 ${tone.bar} transition-all duration-500 group-hover:w-full`}></span>
    </Link>
  );
}